import React from "react";
import styled from "styled-components";
import { SectionHeader } from "../../../../../app/components";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import { makeStyles } from "@material-ui/styles";
import { useNavigate, useParams } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import { useStudyPlan } from "../../../../../app/contexts/study.context";
import SeparateContainer from "../../../../../app/components/separate.Container";
import SideBySide from "../../../../../app/components/sideBySide";
import OutlinedButton from "../../../../../app/components/buttons/outlined";

const renderMonthHeaders = () =>
  [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ].map((month) => (
    <Cell
      key={month}
      variant="header"
    >
      <Typography>
        <strong>{month}</strong>
      </Typography>
    </Cell>
  ));

const CountryEnrollmentSeasonalVariations = ({ country, siteGroup, tab }) => {
  const { canEditPlan } = useStudyPlan();
  const inputClasses = useInputStyles();
  const navigate = useNavigate();
  const { id, planId } = useParams();
  const { enrollmentVariations } = siteGroup;

  return (
    <SeparateContainer>
      <Container>
        <SideBySide>
          <SectionHeader
            paddingBottom={false}
            marginBottom={false}
          >
            Country Enrollment Seasonal Variations
          </SectionHeader>
          {canEditPlan && (
            <OutlinedButton
              style={{ marginBlock: "0.7em", marginInline: "1em" }}
              onClick={() =>
                navigate(
                  `/ctpo/study-plans/${id}/${planId}/countries-and-site-groups#seasonal-variation`,
                  { tabIndex: tab },
                )
              }
            >
              <EditIcon style={{ marginRight: ".3em" }} /> Edit
            </OutlinedButton>
          )}
        </SideBySide>
        <div style={{ padding: "20px" }}>
          <Table>
            <Row>{renderMonthHeaders()}</Row>
            <Row>
              {enrollmentVariations.map((item, index) => (
                <Cell key={index}>
                  <InputBase
                    type="number"
                    classes={inputClasses}
                    value={item.enrollmentSeasonalVariation}
                    disabled
                  />
                </Cell>
              ))}
            </Row>
          </Table>
        </div>
      </Container>
    </SeparateContainer>
  );
};

export default CountryEnrollmentSeasonalVariations;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1em;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  height: 50px;
  border-bottom: 1px solid var(--surface-300);
  &:last-child {
    border: none;
  }
`;

const Cell = styled.div`
  background: ${(p) =>
    p.variant === "header" ? "var(--surface-50)" : "var(--White)"};
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  border-right: 1px solid var(--surface-300);
  &:last-child {
    border: none;
  }
`;

const Table = styled.div`
  display: grid;
  gridtemplaterows: auto auto;
  border: 1px solid var(--surface-300);
  border-radius: 4px;
`;

const useInputStyles = makeStyles(() => ({
  input: {
    textAlign: "center",
    paddingLeft: "1em",
  },
}));
